import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const CONDITION_API = "/studies/interventions/";

export const getAllInterventions = (params) => {
  return axios.get(CONDITION_API, {params: params}).then(res => {
    return res.data;
  });
}

export const addIntervention = (intervention) => {
  return axios.post(CONDITION_API, intervention, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

export const updateIntervention = (id, body) => {
  return axios.put(`${CONDITION_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}

export const deleteIntervention = (id) => {
  return axios.delete(`${CONDITION_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}

export const getSimpleInterventions = () => {
  return axios.get("/studies/interventions-simple/")
  .then(res => res.data.data);
}